import React from "react";

/**
 * Broadcast-style "EN DIRECT" badge — red dot with ping halo + subtle breathing pulse.
 * Size variants: sm (default, used in schedule cards), md (score blocks).
 */
const LiveBadge = ({ size = "sm", className = "" }) => {
  const isMd = size === "md";
  return (
    <span
      data-testid="live-badge"
      className={`inline-flex items-center gap-1.5 ${
        isMd ? "px-2.5 py-1 text-[10px]" : "px-1.5 py-0.5 text-[9px]"
      } bg-red-600 text-white uppercase tracking-[0.15em] font-condensed shadow-[0_0_12px_rgba(230,0,18,0.55)] ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" />
      </span>
      <span className="animate-[pulse_1.8s_ease-in-out_infinite]">
        {isMd ? "EN DIRECT" : "LIVE"}
      </span>
    </span>
  );
};

export default LiveBadge;
